import Api from '../../services/Api/Api';
import {
  PaymentCycle_BIMap,
  SelectPlanClickSource,
} from '../../services/BiLogger/BiLoggerTypes';
import { AdvancedPlansProductData, ProductData } from '../../types';
import { Experiments, PaymentCycle, ProductChangeType } from 'enums';
import { AppProps } from './App';
import { STEP_ACTIONS } from 'stores/App.store';

export class AppController {
  constructor(private readonly props: AppProps) {
    const { appContext, setCouponCode } = this.props.rootStore.appStore;
    const { couponCode } = appContext.requestParamsMap;

    if (couponCode) {
      setCouponCode(couponCode);
    }

    if (this.isValidProductFromUrl()) {
      this.handelPreSelectedProduct();
    }
  }

  isValidProductFromUrl = () => {
    const { products, advancedPlansProducts, requestParamsMap, experiments } =
      this.props.rootStore.appStore.appContext;
    const { productId } = requestParamsMap;

    if (
      experiments[Experiments.DomainUpSell] === 'true' &&
      Boolean(productId)
    ) {
      return true;
    }

    return (
      !!productId &&
      (products.length === 1 || advancedPlansProducts.length === 1)
    );
  };

  handelPreSelectedProduct = () => {
    const {
      appContext,
      setCurrentCycle,
      setCurrentProductWithDefaultCycle,
      setStep,
      activateDirectChecktOut,
      isAnonymous,
    } = this.props.rootStore.appStore;
    const {
      siteGuid,
      requestParamsMap,
      isMobile,
      advancedPlansProducts,
      experiments,
    } = appContext;
    const { paymentCycle, productId } = requestParamsMap;

    const product =
      advancedPlansProducts.find((product) => product.guid === productId) ??
      advancedPlansProducts[0];
    setCurrentProductWithDefaultCycle(product);

    const canGoToStep1 = !isAnonymous && (!isMobile || !!siteGuid);
    let canGoToStep2 = !!siteGuid;
    if (canGoToStep1) {
      setStep(1);
      if (paymentCycle && PaymentCycle[paymentCycle]) {
        setCurrentCycle({
          cycle: PaymentCycle[paymentCycle],
        });
      } else {
        canGoToStep2 = false;
      }

      if (canGoToStep2 && experiments[Experiments.DomainUpSell] !== 'true') {
        activateDirectChecktOut();
      }
    }
  };

  onCycleSelect = () => {
    const { changeStep } = this.props.rootStore.appStore;
    changeStep(STEP_ACTIONS.INCREMENT, () => {});
  };

  onSelectProduct = async (
    product: ProductData | AdvancedPlansProductData,
    clickSource?: SelectPlanClickSource,
    useDefaultCycle = true,
  ) => {
    const {
      changeStep,
      setCurrentProductWithDefaultCycle,
      setCurrentProduct,
      currentCycle,
      isChangePlan,
      openChangePlanModal,
      appContext,
      isDayful,
      appFlow,
    } = this.props.rootStore.appStore;
    if (useDefaultCycle) {
      setCurrentProductWithDefaultCycle(product);
    } else {
      setCurrentProduct(product);
    }

    if (
      isChangePlan &&
      product.productChangeType === ProductChangeType.Downgrade
    ) {
      openChangePlanModal();
    } else {
      changeStep(STEP_ACTIONS.INCREMENT, (fromStep, toStep) => {
        const biLoggerParams = {
          ppType: product.type,
          cycle: PaymentCycle_BIMap[currentCycle],
          productId: product.id,
          productGuid: product.guid,
          referralAdditionalInfo: 'select-button',
          packagePickerType: appContext.packagePickerType,
          cartFlow: appFlow,
        };
        if (isDayful) {
          appContext.biLogger.logDayfulCyclesPageViewBiEvent(biLoggerParams);
        } else {
          appContext.biLogger.logSelectPlanBiEvent({
            ...biLoggerParams,
            clickType: clickSource,
          });
        }
      });
    }
  };

  get fetchOrderPageFunction() {
    const { isDynamicOffering } = this.props.rootStore.appStore.appContext;

    return isDynamicOffering
      ? Api.fetchDynmicOrderPageData
      : Api.fetchOrderPageDataV2;
  }
}
